import { render } from "./SetFilters.vue?vue&type=template&id=38d18394"
import script from "./SetFilters.vue?vue&type=script&lang=js"
export * from "./SetFilters.vue?vue&type=script&lang=js"

import "./SetFilters.vue?vue&type=style&index=0&id=38d18394&lang=scss"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__